import store from '@/store/store'

export default store



// WEBPACK FOOTER //
// ./src/store/index.js